import React from 'react'
import _ from 'lodash'
import * as NavActions from 'x/utils/navigation'
import { IPackageDetails, ISubscriptionPackageList, IXScreenProps, SubscriptionPackageListItems } from 'x/types'
import * as util from 'x/utils/util'

interface IBaseActivePackageDetailProps extends IXScreenProps {
  profile: any
  subscription: any
  fetchSubscription: any
  hideSubscription: any
  navigation: any
}

interface IBaseActivePackageDetailState {
  subscriptionPackageList: ISubscriptionPackageList
  packageDetails: IPackageDetails
  currentPackageBillingCycle: SubscriptionPackageListItems[]
}

export default abstract class BaseActivePackageDetail extends React.Component<
  IBaseActivePackageDetailProps,
  IBaseActivePackageDetailState
> {
  // abstract async handleSubmitForm(response: any): Promise<void>

  constructor(props) {
    super(props)
    // @ts-ignore
    this.state = {
      subscriptionPackageList: null,
      packageDetails: null,
      currentPackageBillingCycle: null,
    }
    // this.webview = React.createRef()
    // this.imgManagerIDRef = React.createRef()
  }

  async componentDidMount() {
    const params = util.getNavParams(this.props)
    // console.log(`params `, params)
    const { subscriptionPackageList } = params

    await util.setStatePromise(this, {
      subscriptionPackageList,
    })
    await this._setCurrentPackageBillingCycle()
  }

  _setCurrentPackageBillingCycle = async () => {
    const { subscription } = this.props
    const currentPackageBillingCycle = subscription.has('current_package_billing_cycle')
      ? subscription.get('current_package_billing_cycle').toJS()
      : null

    // console.log('currentPackageBillingCycle / => ', currentPackageBillingCycle)
    if (_.isNil(currentPackageBillingCycle)) {
      return
    }

    // const newcurrentPackageBillingCycle = []
    // @ts-ignore
    const newcurrentPackageBillingCycle = currentPackageBillingCycle.sort((a, b) => new Date(a.start_date) - new Date(b.start_date))
    await util.setStatePromise(this, {
      currentPackageBillingCycle: newcurrentPackageBillingCycle,
    })
  }

  _navToInAppPurchaseView = (mode: 'buy_package' | 'continue_package' | 'upgrade') => {
    const { subscriptionPackageList } = this.state
    const { navigation } = this.props
    navigation.dispatch(
      NavActions.navToInAppPurchaseView({
        subscriptionPackageList,
        mode,
        callBackSucceedPaymentIos: () => this.callBackSucceedPaymentIos(),
        succeedPaymentCallBack: () => this.callBackSucceedPayment(),
      })
    )
  }

  callBackSucceedPaymentIos = () => {
    const params = util.getNavParams(this.props)
    // console.log(`params `, params)
    const { callBackSucceedPaymentIos } = params
    if (_.isFunction(callBackSucceedPaymentIos)) {
      callBackSucceedPaymentIos()
    }
  }

  callBackSucceedPayment = () => {
    const params = util.getNavParams(this.props)
    // console.log(`params `, params)
    const { succeedPaymentCallBack } = params
    if (_.isFunction(succeedPaymentCallBack)) {
      succeedPaymentCallBack()
    }
  }

  _navToInAppPurchasePerPackageView = () => {
    const { navigation } = this.props
    const { subscriptionPackageList } = this.state
    const canPerPackage = util.PerPackageCheck(subscriptionPackageList)
    // console.log('canPerPackage => ', canPerPackage)
    if (!canPerPackage) {
      return
    }
    navigation.dispatch(
      NavActions.navToInAppPurchasePerPackageView({
        subscriptionPackageList,
        callBackSucceedPaymentIos: () => this.callBackSucceedPaymentIos(),
        popView: 3,
      })
    )
    // this._navToInAppPurchaseView('continue_package')
  }
}
